import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, type UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyMutations} from '../../api'
import type {CreateReportRequest, ReportSummaryDto} from '../../types'
import {useRiskSurveyTranslation} from '../useRiskSurveyTranslation'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useImportReport = (
  options?: UseMutationOptions<ReportSummaryDto, AxiosError, CreateReportRequest>
) => {
  const {t} = useRiskSurveyTranslation()
  const queryClient = useQueryClient()

  return useMutation<ReportSummaryDto, AxiosError, CreateReportRequest>({
    mutationFn: (data) => riskSurveyMutations.importReport(data),
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      spawnSuccessToast(t('import.success'))
      void options?.onSuccess?.(data, variables, onMutateResult, context)
    },
    onError: (error, variables, onMutateResult, context) => {
      const detail =
        (error.response?.data as {title?: string})?.title ?? error.message ?? t('import.error')
      spawnErrorToast(detail)
      void options?.onError?.(error, variables, onMutateResult, context)
    },
    onSettled: (data, error, variables, onMutateResult, context) => {
      void queryClient.invalidateQueries({queryKey: riskSurveyQueryKeys.reports.lists()})
      void queryClient.invalidateQueries({queryKey: riskSurveyQueryKeys.rias.lists()})
      void options?.onSettled?.(data, error, variables, onMutateResult, context)
    }
  })
}
